import { api, POST } from '../ConsumeApiController';
import CompanyRoutes from "../../apiRoutes/CompanyRoutes";

/**
 * Obtiene el horario de cualquier recurso (merchant, asset, employee)
 */
export async function GetSchedules(type, id) {
    try {
        const response = await api.get(CompanyRoutes.Schedules.GetAll(type,id));
        
        // Retornamos estructura estandarizada
        if(response.data && response.success) {
            return { success: true, data: response.data };
        } else {
            return { success: false, message: response.data.message || 'Error al obtener horarios' };
        }
    } catch (error) {
        console.error(error);
        return { success: false, message: 'Error de conexión' };
    }
}

/**
 * Guarda el horario semanal
 */
export async function SaveSchedule(type, id, scheduleData) {
    try {
        const params = {
            type: type,
            id: id,
            schedules: scheduleData
        };

        // POST /api/company/schedules
        // Usamos tu helper POST o api.post directo según prefieras
        // Asumo que tu backend espera JSON en el body
        const response = await api.post(CompanyRoutes.Schedules.Save, params);
        
        if(response.data && response.success) {
            return { success: true, message: response.message };
        } else {
            return { success: false, message: response.data.message || 'Error al guardar' };
        }
    } catch (error) {
        console.error(error);
        return { success: false, message: 'Error de conexión al guardar' };
    }
}